import { h } from '../../src/ui/dom';

/** One site for everyone: there is no family sign-in. Old /family/ links redirect here (public/_redirects). */
export const placeHref = (slug: string) => `/place/?p=${slug}`;
export const placesHref = () => '/places/';
export const beenHref = () => '/been/';

/** The planner lives on its own subdomain (plan.sailingcos.com); in development it is the local planner. */
export function plannerUrl(host: string): string {
  if (host === '127.0.0.1' || host === 'localhost') return 'http://127.0.0.1:9082/';
  return `https://plan.${host.replace(/^www\./, '')}/`;
}

/** The tabs with the "Log in to plan" button at the right: it opens the planner, which asks for Steve's login. */
const withLogin = (nav: HTMLElement) =>
  h('div', { class: 'nav-row' }, nav, h('a', { class: 'btn nav-login', href: plannerUrl(location.hostname) }, 'Log in to plan'));

const link = (href: string, text: string, on: boolean) => h('a', { href, class: on ? 'nav-link on' : 'nav-link', ...(on ? { 'aria-current': 'page' } : {}) }, text);

/** The site's links: home, where we've been, where's next (the places guide), the boat and what to pack. */
export function publicNav(active: 'home' | 'been' | 'places' | 'boat' | 'packing'): HTMLElement {
  return withLogin(h('nav', { class: 'site-nav', 'aria-label': 'Pages' },
    link('/', 'Home', active === 'home'), link('/been/', 'Where we’ve been', active === 'been'), link('/places/', 'Where’s next', active === 'places'), link('/boat/', 'The boat', active === 'boat'), link('/packing/', 'Packing', active === 'packing')));
}
